import { useI18n } from '@/hooks/useI18n';
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface EmptyProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function Empty({ title, description, action, className }: EmptyProps) {
  const { t } = useI18n();
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-2 rounded-[14px] border border-dashed border-line-2 bg-bg-1 px-6 py-10 text-center',
        className,
      )}
    >
      <div className="font-tech text-[10px] uppercase tracking-[0.22em] text-text-4">
        {t('// vide', '// empty')}
      </div>
      <h2 className="text-[15px] font-semibold text-text-1">{title}</h2>
      {description && <p className="max-w-md text-[13px] text-text-3">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
